<template>
    <section id="grid">
       <div v-for="r in results" v-bind:key="r.id" class="item-link">
            <router-link :to="{name: `${r.type}-detail`, params: {id: r.id}}" style="margin-right: 20px;">
                <div class="image-container">
                    <figure>
                        <img v-if="displayImg(r)" :src="displayImg(r)" :alt="displayTitle(r)">
                        <div class="media-type" v-else-if="displayMedia(r)">
                        <p>
                            {{ displayMedia(r) }}
                        </p>
                        </div>
                        <img v-else class="no-image" src="../assets/images/icon-missing-image.svg" :alt="displayTitle(r)">
                    </figure>
                    <div class="save-list-scrim" :class="{saved: isSaved(r.id), selected: isSelected(r.id)}">
                        
                        <span v-if="!isSaved(r.id)" class="save-input">
                            <button type="button" @click="updateSelection({id: r.id, type: 'selected'}, $event)">
                                <span class="text" v-if="!isSelected(r.id)">{{ $t('labels.select_item') }}</span>
                                <span class="icon-checkbox" aria-hidden="true"></span>
                            </button>
                        </span>
                        
                        <span v-if="isSaved(r.id)" class="bookmark">
                            <button
                                class="unsave-btn btn bookmark-btn"
                                type="button"
                                @click="updateSave({id: r.id, checkLimit: false}, $event)"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="28" viewBox="0 0 20 28" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V28L9.91852 20.4479L19.8333 28V0H0Z" fill="#93DA72"/>
                                </svg>
                            </button>
                            <button type="button" @click="updateSave({id: r.id, checkLimit: false}, $event)">
                                <span class="text">{{ $t('labels.remove_from_list') }}</span>
                            </button>
                        </span>
                    </div>
                </div>
                <p class="h5">{{ displayTitle(r) }}</p>
                <p v-if="displaySubtitle(r)">{{ displaySubtitle(r) }}</p>
            </router-link>
       </div>
    </section>
</template>

<script>
import SavedListMixin from '../mixins/SavedListMixin'
import ResultsImageMixin from '../mixins/ResultsImageMixin'

export default {
    mixins: [SavedListMixin, ResultsImageMixin],
    props: {
        "results": Array,
    },
    data: function () {
        return {
            savedItems: []
        }
    },
    methods: {
        displayTitle (item) {
            return item.title;
        },
        displaySubtitle (item) {
            if (item.type == 'artifact') {
               return item.artifact_num || '—';
            } else {
                if (item.control_num) {
                    return item.control_num[0];
                } else if (item.accession_num) {
                    return Array.isArray(item.accession_num) ? item.accession_num[0] : item.accession_num;
                } else {
                   return '—';
                }
            }
        }
    }, 
    async mounted () {
        this.$store.dispatch('list/saved_ids');
    }
}
</script>

<style scoped lang="scss">
#grid {
    display: grid;
    grid-template-columns: repeat(4, 25%);
    /*grid-template-rows: 1fr 1fr 1fr;*/
    gap: 0px 0px;

    .item-link {  
        margin: $s1;
        text-decoration: none;
        word-break: break-word;

        .image-container {
            width: 100%;
            padding-bottom: 100%;
            margin-bottom: $s1;
            position: relative;
            background: $off-white;

            figure {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                margin: 0;

                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    object-fit: contain;
                    height: 100%;
                    width: 100%;
                    max-width: 100%;

                    &.no-image {
                        opacity: .7;
                        height: 50%;
                        width: 50%;
                        margin: 23% auto;
                        display: block;
                    }
                }

                .media-type {
                    font-family: 'Futura';
                    font-size: 1rem;
                    color: $dark-gray2;
                    text-transform: uppercase;
                    opacity: .6;
                    border: solid $dark-gray2 2px;
                    border-radius: 50%;
                    height: 34%;
                    width: 34%;
                    min-height: 60px;
                    min-width: 60px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    p {
                        margin: 0;
                    }
                }
            }

            .save-list-scrim {
                display: none;

                button {
                    cursor: pointer;
                    border: none;
                    background: none;
                    display: flex;
                    align-items: center;
                    padding: 0;
                    color: $white;
                }

                .save-input { 

                    .icon-checkbox {
                        border: solid 2px $menu-gray;
                        background: $white;
                        display: inline-block;
                        height: 18px;
                        width: 18px;
                        margin-left: .5rem;
                    }
                }


                &.saved {
                    display: block;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: none;
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-start;
                    padding: .5rem;

                    span.text {
                        display: none;
                    }

                    .bookmark{
                        display: block;
                        position: absolute;
                        top: -6px;
                        left: 10px;
                        z-index: 2;

                        button{
                            position: absolute;
                            top: 15px;
                            left: 30px;
                            width: max-content;
                            z-index: 1;

                            &.bookmark-btn {
                                top: 0;
                                left: 0;
                            }
                        }
                    }

                }

                &.selected {
                    display: block;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: none;
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-start;
                    padding: .5rem;

                    .icon-checkbox {
                        border: $cwm-green 2px solid;
                        background: $cwm-green;

                        &:after {
                            height: 18px;
                            content: url('../assets/images/icon-check.svg');
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    }
                }
            }


            &:hover {
                .save-list-scrim {
                    display: block;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: rgba(0,0,0,0.5);
                    display: flex;
                    color: white;
                    justify-content: flex-end;
                    align-items: flex-start;
                    padding: .5rem;

                    &.saved {
                        span.text {
                            color: white;
                            display: block;
                        }

                    }
                }
            }
        }

        p,a {
            color: $dark-gray1;
            font-size: 1rem;
            line-height: 1.3;
            margin: 0;
            text-decoration: none;
            text-transform: unset;
            letter-spacing: unset;
        }

        p.h5{
            font-weight: 700;
            font-family: $futuraBold;
            text-transform: uppercase;
        }

        p:not(.h5) {
            font-size: 1rem;
            margin-top: .5rem;
        }
    }
}

@media (max-width: $mq-max-width-tablet) {
    #grid {
        grid-template-columns: repeat(3, 33%);

        .item-link {
            margin: .5rem;
            p {
                line-height: 1.35;
            }
        }
    }
}

@media (max-width: $mq-max-width-mobile) {
    #grid {
        grid-template-columns: repeat(2, 50%);
    }
}

@media print {
    #grid {
        display: grid;
        grid-template-columns: repeat(4, 25%);
        grid-template-rows: 1fr 1fr 1fr;
        gap: 0px 0px;

        .item-link,
        p,
        figure {
            position: relative;
            page-break-inside: avoid;
        }

        .h5 {
            font-size: .8rem;
            font-weight: normal;
            font-family: 'Futura';
        }
    }
}


</style>